import { render, staticRenderFns } from "./ColorWidget.vue?vue&type=template&id=38e0343a&lang=pug&"
import script from "./ColorWidget.vue?vue&type=script&lang=js&"
export * from "./ColorWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports